import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';

/** Réception du JWT après redirect Google → `/auth/google/callback` → ici. */
const LoginOAuthCallbackPage: React.FC = () => {
  const [message, setMessage] = useState('Finalisation de la connexion…');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if (!token) {
      setMessage('Paramètre token manquant.');
      setTimeout(() => {
        window.location.replace('/login?oauth_error=no_token');
      }, 1500);
      return;
    }
    localStorage.setItem('auth_token', token);
    window.location.replace('/');
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50">
      <Loader2 className="w-10 h-10 text-indigo-600 animate-spin mb-4" />
      <p className="text-gray-700">{message}</p>
    </div>
  );
};

export default LoginOAuthCallbackPage;
